<app-img-header
  title="Productos"
  alt="Productos"
  image="/assets/images/catalogos/productos/intro.jpg"
  [contentTemplate]="template"
>
</app-img-header>
<app-preloader *ngIf="isLoading"></app-preloader>
<app-notifications></app-notifications>

<main class="main">
  <div id="detail">
    <div class="pageWidth">
      <div class="actionsWrapper">
        <button class="tertiary" (click)="addNewProduct()"><i class="icon"></i> Nuevo producto</button>
      </div>

      <div *ngIf="data.length == 0" class="noData">No hay información disponible</div>
      <div class="customTable listadoProductos" *ngIf="data.length != 0">
        <div class="header">
          <div class="cell nombre">Nombre</div>
          <div class="cell tipo">Tipo</div>
          <div class="cell marca">Marca</div>
          <div class="cell submarca">Submarca</div>
          <div class="cell anio">Año</div>
          <div class="cell condicion">Condición</div>
          <div class="cell estado">Estado</div>
          <div class="cell acciones"></div>
        </div>

        <div class="row" *ngFor="let item of data">
          <div class="cell nombre">{{ item.name }}</div>
          <div class="cell tipo">
            {{ getProductTypeDescription(item.modelType) }}
          </div>

          <div class="cell marca">
            {{ item.brand }}
          </div>

          <div class="cell submarca">{{ item.subBrand }}</div>
          <div class="cell anio">{{ item.year }}</div>
          <div class="cell condicion">
            {{ item.classification ? 'Nuevo' : 'Seminuevo' }}
          </div>
          <div class="cell estado">
            {{ item.enabled ? 'Activo' : 'Inactivo' }}
          </div>
          <div class="cell acciones">
            <a tp="Editar producto" class="edit" (click)="edit(item.id)">Editar</a>
            <a
              (click)="view(item.id)"
              class="view"
              [routerLink]="['financial-product/new-product/read-only/:id']"
              tp="Ver producto"
              >Ver</a
            >
          </div>
        </div>
      </div>
      <button class="tertiary" (click)="addNewProduct()"><i class="icon"></i> Nuevo producto</button>
      <div *ngIf="hasData">
        <app-paginator
          [total]="total"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (changePage)="handlePage($event)"
        ></app-paginator>
      </div>
    </div>
    <ng-template #template>
      <div class="wrapperG3">
        <div>
          <label>Tipo de producto</label>
          <app-select
            [options]="financialCalculator.productType"
            placeholder="Buscar por tipo de producto"
            key="name"
            [resetSelect]="reset"
            (optionSelected)="filter($event, 'modelType')"
          ></app-select>
        </div>
        <div>
          <label>Marca</label>
          <app-select
            [options]="searchBrand"
            [placeholder]="'Buscar por marca'"
            (optionSelected)="filter($event, 'brandId')"
            [resetSelect]="reset"
          ></app-select>
        </div>
        <div>
          <label>Submarca</label>
          <app-select
            [options]="searchSubBrand"
            [placeholder]="'Buscar por submarca'"
            (optionSelected)="filter($event, 'subBrandId')"
            [resetSelect]="resetSubBrand"
          ></app-select>
        </div>
        <div>
          <label>Año</label>
          <app-select
            [options]="searchYear"
            [placeholder]="'Buscar por año'"
            (optionSelected)="filter($event, 'year')"
            [resetSelect]="reset"
          ></app-select>
        </div>
        <div>
          <label>Condición</label>
          <app-select
            [options]="conditions"
            [placeholder]="'Buscar por condición'"
            (optionSelected)="filter($event, 'classification')"
            [resetSelect]="reset"
          ></app-select>
        </div>
        <div>
          <label>Estado</label>
          <app-select
            [options]="financialProductStatus"
            [placeholder]="'Buscar por estado'"
            (optionSelected)="filter($event, 'enabled')"
            [resetSelect]="reset"
          ></app-select>
        </div>
      </div>

      <div class="filtersActions">
        <button class="primary" (click)="search()">Buscar</button>
        <button class="secondary" (click)="resetFilters()">Limpiar filtros</button>
      </div>
    </ng-template>
  </div>
</main>
